export default "/directory/static/is_videographer.8af62a89.svg";